import { CPIManifest } from 'models'

export const getIntegrationLogoFromManifest = (integrationName: string, manifestData: CPIManifest | null) => {
  if (!manifestData) return ''

  const supportedIntegration = manifestData.supported_integrations.find((n) => n.name === integrationName)

  if (supportedIntegration) {
    return `/icons/rounded/${supportedIntegration.logo_url}`
  }

  return '/icons/rounded/crowdstrike_falcon_icon.svg'
}

export const openInNewTab = (url: string) => {
  window.open(url, '_blank', 'noreferrer')
}
